import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import StatusBadge from './StatusBadge';

const LeadTableMobile = ({ leads }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const handleNavigateToDetails = (lead, e) => {
    e?.stopPropagation();
    
    // Validate lead ID before navigation
    if (!lead?.id) {
      console.error('Cannot navigate to lead details: Lead ID is missing', lead);
      alert('Unable to view lead details: Lead ID is missing. Please refresh the page and try again.');
      return;
    }
    
    console.log('Navigating to lead details with ID:', lead?.id);
    navigate(`/lead-details/${lead?.id}`);
  };

  const handleCardClick = (lead) => {
    // Validate lead ID before navigation
    if (!lead?.id) {
      console.error('Cannot navigate to lead details: Lead ID is missing', lead);
      alert('Unable to view lead details: Lead ID is missing. Please refresh the page and try again.');
      return;
    }
    
    console.log('Card clicked - Navigating to lead details with ID:', lead?.id);
    navigate(`/lead-details/${lead?.id}`);
  };

  return (
    <div className="space-y-4">
      {leads?.map((lead) => (
        <div 
          key={lead?.id} 
          className={`bg-card rounded-lg p-4 border border-border elevation-1 hover:elevation-2 transition-all duration-200 ${lead?.id ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
          onClick={lead?.id ? () => handleCardClick(lead) : undefined}
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name="User" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <p className="font-medium text-foreground">{lead?.customerName}</p>
                <p className="text-xs text-muted-foreground">{lead?.email}</p>
              </div>
            </div>
            <StatusBadge status={lead?.status} />
          </div>
          
          <div className="space-y-3 mb-3">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Property Type</p>
                <p className="text-sm text-foreground font-medium">{lead?.propertyType}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Referral Type</p>
                <p className="text-sm text-foreground font-medium">{lead?.referralType}</p>
              </div>
            </div>
            <div className="w-full">
              <p className="text-xs text-muted-foreground mb-1">Submitted</p>
              <p className="text-sm text-foreground font-medium">{formatDate(lead?.submissionDate)}</p>
            </div>
          </div>
          
          <Button 
            variant="outline" 
            size="sm" 
            iconName="Eye" 
            iconPosition="left"
            fullWidth
            onClick={(e) => handleNavigateToDetails(lead, e)}
            disabled={!lead?.id}
          >
            View Details
          </Button>
        </div>
      ))}
    </div>
  );
};

export default LeadTableMobile;